import { Injectable } from '@angular/core'
import { HttpClient, HttpHeaders } from '@angular/common/http'
import { Observable } from 'rxjs'
import { Programa } from '../models/programa.model'
import { environment } from 'src/environments/environment'
import { Disciplina } from '../models/disciplina.model'
import { Docente } from '../models/docente.model'
import { DisciplinaPrograma } from '../models/disciplina-programa.model'
import { DocentePrograma } from '../models/docente-programa.model'

@Injectable({
  providedIn: 'root'
})
export class SispgService {

  private baseUrl: string

  constructor(private http: HttpClient) {
    this.baseUrl = environment.sispgUrlApi
  }

  programas(locale: string): Observable<Programa[]> {
    if (['en'].includes(locale)) {
      return this.http.get<Programa[]>(`${this.baseUrl}/publico/programas/${locale.toLowerCase()}`, { headers: new HttpHeaders(), withCredentials: false })
    }
    return this.http.get<Programa[]>(`${this.baseUrl}/publico/programas/pt`, { headers: new HttpHeaders(), withCredentials: false })
  }

  disciplinasPrograma(locale: string): Observable<DisciplinaPrograma[]> {
    if (['en'].includes(locale)) {
      return this.http.get<DisciplinaPrograma[]>(`${this.baseUrl}/publico/programas/disciplinas/${locale.toLowerCase()}`, { headers: new HttpHeaders(), withCredentials: false })
    }
    return this.http.get<DisciplinaPrograma[]>(`${this.baseUrl}/publico/programas/disciplinas/pt`, { headers: new HttpHeaders(), withCredentials: false })
  }

  docentesPrograma(locale: string): Observable<DocentePrograma[]> {
    if (['en'].includes(locale)) {
      return this.http.get<DocentePrograma[]>(`${this.baseUrl}/publico/programas/docentes/${locale.toLowerCase()}`, { headers: new HttpHeaders(), withCredentials: false })
    }
    return this.http.get<DocentePrograma[]>(`${this.baseUrl}/publico/programas/docentes/pt`, { headers: new HttpHeaders(), withCredentials: false })
  }

  disciplinas(id: number, locale: string): Observable<Disciplina[]> {
    if (['en'].includes(locale)) {
      return this.http.get<Disciplina[]>(`${this.baseUrl}/publico/programas/${id}/disciplinas/${locale.toLowerCase()}`, { headers: new HttpHeaders(), withCredentials: false })
    }
    return this.http.get<Disciplina[]>(`${this.baseUrl}/publico/programas/${id}/disciplinas/pt`, { headers: new HttpHeaders(), withCredentials: false })
  }

  docentes(id: number, locale: string): Observable<Docente[]> {
    if (['en'].includes(locale)) {
      return this.http.get<Docente[]>(`${this.baseUrl}/publico/programas/${id}/docentes/${locale.toLowerCase()}`, { headers: new HttpHeaders(), withCredentials: false })
    }
    return this.http.get<Docente[]>(`${this.baseUrl}/publico/programas/${id}/docentes/pt`, { headers: new HttpHeaders(), withCredentials: false })
  }
}
